import {
  AdvancedFiltersComponentModule,
  AdvancedFiltersService,
  AdvancedFiltersServiceModule,
} from '@b2b/common/components/advanced-filters';
import { EmptySectionComponentModule } from '@b2b/common/components/empty-section';
import { NoticesComponentModule } from '@b2b/common/components/notices';
import { TabsComponentModule } from '@b2b/common/components/tabs';
import { FocusDirectiveModule } from '@b2b/common/directives';
import { NoticeFactory } from '@b2b/common/factories/notice';
import { CartService, CartServiceModule } from '@b2b/common/services';
import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { SidebarService, SidebarServiceModule } from '@b2b/common/services/sidebar';
import { TODO, UIBModal, UIBModalService } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';
import { MembershipListCardholdersControllerModule } from './MembershipListCardholdersController';
import { MembershipListOrganizationsControllerModule } from './MembershipListOrganizationsController';

MembershipListController.$inject = [
  '$scope',
  '$filter',
  '$state',
  '$timeout',
  '$uibModal',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'GridDefinitionFactory',
  'GridStateFactory',
  'NoticeFactory',
  'ViewStateService',
  'FeatureToggleService',
  'PermissionsService',
  'CartService',
  'SidebarService',
  'AdvancedFiltersService',
];

function MembershipListController(
  $scope: IScope & { membershipList: TODO },
  $filter: IFilterService,
  $state: StateService,
  $timeout: ITimeoutService,
  $uibModal: UIBModalService,
  ApiService: ApiService,
  CalendarService: TODO,
  HelpersService: TODO,
  GridDefinitionFactory: TODO,
  GridStateFactory: TODO,
  NoticeFactory: NoticeFactory,
  ViewStateService: TODO,
  FeatureToggleService: TODO,
  PermissionsService: PermissionsService,
  CartService: CartService,
  sidebarService: SidebarService,
  advancedFiltersService: AdvancedFiltersService
) {
  $scope.membershipList = {
    states: {
      individual: {
        value: 'initial',
        text: {
          emptySectionHeader: 'Search Individual & Family Memberships',
          searchPlaceholder:
            'Search by Name, Email, Phone Number, Membership ID, External Customer ID, Acme Customer ID, or Barcode ID',
        },
      },
      organizations: {
        value: 'list',
        text: {
          emptySectionHeader: 'Search Organization Memberships',
          searchPlaceholder:
            'Search by Name, Email, Phone Number, Organization Name, Membership ID, External Customer ID, Acme Customer ID, or Barcode ID',
        },
      },
    },
    tabs: [
      { name: 'individual', label: 'Individual & Family Memberships' },
      { name: 'organizations', label: 'Organization Memberships' },
    ],
    model: [],
    filtered: [],
    searchQuery: ViewStateService.getStateProperty('membership.list', 'search', ''),
    searchType: 'individual',
    searchCardholders: false,
    searchPlaceholder: '',
    /**
     * @type {'idle' | 'loading' | 'error'}
     */
    state: 'idle',
    queryTimer: false,
    notice: new NoticeFactory(),
    advancedFiltersFields: [
      {
        type: 'section',
        label: 'Search by any combination of these fields:',
      },
      {
        type: 'field',
        ndx: 0,
        label: 'First Name',
        format: 'Text',
        value: 'firstName',
      },
      {
        type: 'field',
        ndx: 1,
        label: 'Last Name',
        format: 'Text',
        value: 'lastName',
      },
      {
        type: 'field',
        ndx: 2,
        label: 'Address',
        format: 'Text',
        value: 'address',
      },
      {
        type: 'field',
        ndx: 3,
        label: 'ZIP',
        format: 'Text',
        value: 'zip',
      },
      {
        type: 'field',
        ndx: 4,
        label: 'Email',
        format: 'Text',
        value: 'email',
      },
      {
        type: 'section',
        label: 'Or search by one of the following:',
      },
      {
        type: 'field',
        ndx: 5,
        label: 'Membership number or Barcode',
        format: 'Text',
        value: 'memberId',
      },
      {
        type: 'field',
        ndx: 6,
        label: 'Card name',
        format: 'Text',
        value: 'cardName',
      },
    ],
    paramsCustomFields: {
      operator: 'and',
      fields: [],
    },

    init: function () {
      const self = $scope.membershipList;

      self.setContentTitle(self.searchType);

      // Membership List based event
      $scope.$on('MembershipList::Loaded', this.onMembershipListUpdate);
      $scope.$on('MembershipList::Error', this.onMembershipListError);
      $scope.$on('$destroy', $scope.$watch('membershipList.searchCardholders', this.onSearchCardholdersUpdate));
      $scope.$on('$destroy', $scope.$watch('membershipList.searchType', this.onSearchTypeUpdate));
    },

    setContentTitle: function (stateName) {
      const self = $scope.membershipList;

      switch (stateName) {
        case 'individual':
          if (
            FeatureToggleService.check('TENANT_CART') &&
            PermissionsService.check(['ORDER_CREATE', 'ACCT_ORDERS_CREATE'])
          ) {
            $scope.$emit('Application::contentTitleChange', {
              title: 'Individual & Family Memberships',
              buttonRight: {
                label: '+ New Membership',
                permissions: 'MEMBERSHIP_SALES',
                action: function () {
                  if (!CartService.hasOrderContact()) {
                    $state.go('application.membership.retail');
                  } else {
                    self.showMembershipMessage();
                  }
                },
              },
            });

            return;
          }

          $scope.$emit('Application::contentTitleChange', { title: 'Individual & Family Memberships' });
          break;

        case 'organizations':
          $scope.$emit('Application::contentTitleChange', { title: 'Organization Memberships' });
          break;
      }
    },

    resetTabStates: function () {
      const self = $scope.membershipList;

      self.states.individual.value = 'initial';
      self.states.organizations.value = 'list';
    },

    loadTab: function (searchType) {
      const self = $scope.membershipList;

      self.resetTab(searchType);

      ViewStateService.setState('membership.list', { search: self.searchQuery });
    },

    resetTab: function (searchType) {
      const self = $scope.membershipList;
      const initialSearchType = searchType || 'individual';

      self.resetTabStates();
      self.states[initialSearchType].value = 'list';
    },

    onSelectedTabChange: function (props: { tab: { name: string } }) {
      const self = $scope.membershipList;

      self.resetTabStates();
      self.searchType = props.tab.name;
      self.setContentTitle(self.searchType);
    },

    onFilterbarSubmit: function (props: { model: string }) {
      const self = $scope.membershipList;

      self.searchQuery = props.model;
      self.query();
    },

    onAdvancedFiltersClear: function () {
      const self = $scope.membershipList;

      self.paramsCustomFields.fields = [];
      self.paramsCustomFields.operator = 'and';

      // Always use basic search when clearing advanced filters
      self.query();
    },

    onAdvancedFiltersSubmit: function (props: {
      rawFilters: Record<string, any>;
      fields: Array<any>;
      operator: string;
    }) {
      const self = $scope.membershipList;

      self.resetTab();

      self.paramsCustomFields.fields = props.fields;
      self.paramsCustomFields.operator = props.operator;

      const filters = props.fields.reduce(function (filtersMap, field) {
        filtersMap[field.name] = field.values.join(',');
        return filtersMap;
      }, {});

      self.queryWithAdvancedSearch({ filters: filters });
    },

    onAdvancedFiltersClose: function () {
      sidebarService.hide();
    },

    query: function () {
      const self = $scope.membershipList;

      // Clear advanced filters params
      advancedFiltersService.clearAllComponentFilters({ name: 'membershipList', emitEvent: false });

      // next tick
      ViewStateService.resetState('membership.list');

      $timeout(function () {
        $scope.$broadcast('MembershipListController::Search', {
          searchType: self.searchType,
          searchQuery: self.searchQuery,
          searchCardholders: self.searchCardholders,
        });
      }, 0);
    },

    queryWithAdvancedSearch: function (props: { filters: Record<string, string> }) {
      const self = $scope.membershipList;

      // Clears basic search
      self.searchQuery = '';

      // next tick
      ViewStateService.resetState('membership.list');

      $timeout(function () {
        $scope.$broadcast('MembershipListController::AdvancedSearch', {
          filters: props.filters,
        });
      }, 0);
    },

    process: function (members) {
      const formatSortDate = function (value) {
        return $filter('date')(CalendarService.parseDate(value), HelpersService.dateFormats.sortDate);
      };

      members = Array.isArray(members) ? members : [];

      for (let i = 0, ii = members.length; i < ii; i++) {
        members[i].membershipJoinedDateDisplay = formatSortDate(members[i].membershipJoinedDate);
        members[i].membershipExpirationDateDisplay = formatSortDate(members[i].membershipExpirationDate);
      }

      return members;
    },

    showMembershipMessage: function () {
      const self = $scope.membershipList;
      const membership = CartService.getTransactingMembership();
      const orderContact = CartService.getOrderContact();
      const title = 'Proceeding will clear the cart';
      const message = [
        HelpersService.getFullName(orderContact),
        ' already has a membership: ',
        membership.membershipCategory,
        ' (expiring ',
        membership.membershipExpirationDateDisplay,
        '). Adding a new membership will remove the currently transacting member and clear contents of the cart.',
      ].join('');

      const showMessageModal = $uibModal.open({
        templateUrl: 'views/application/views/membership/list/modals/member/member.tpl.html',
        size: 'md',
        controller: 'MembershipListModalsMemberController',
        resolve: {
          modalTitle: function () {
            return title;
          },
          modalMessage: function () {
            return message;
          },
          showRenew: function () {
            return false;
          },
        },
      });

      showMessageModal.result
        .then(function (response) {
          const props = {
            membershipId: membership.id,
            customerId: orderContact?.customerId,
          };

          if (response === 'renew') {
            self.goToState(props, 'application.membership.retail');
          } else if (response === 'clear') {
            CartService.cancelCart().then(self.success.clearMember, self.success.clearMember);
          }
        })
        .catch(function (response) {
          // Close modal, do nothing
        });
    },

    showMessage: function (title, message, okText, successCallBack, errorCallBack) {
      if (message) {
        const showMessageModal: UIBModal<any> = $uibModal.open({
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          size: 'md',
          controller: 'ConfirmModalController',
          resolve: {
            modalTitle: function () {
              return title;
            },
            modalMessage: function () {
              return message;
            },
            okText: function () {
              return okText || 'Done';
            },
          },
        });

        // Invoked when modal completes with close(params)
        showMessageModal.result.then(
          function (response) {
            if (typeof successCallBack === 'function') {
              successCallBack(response);
            }
          },
          function (response) {
            if (typeof errorCallBack === 'function') {
              errorCallBack(response);
            }
          }
        );
      }
    },

    success: {
      init: function (response) {},
      clearMember: function (response) {
        $scope.$emit('Cart::Close');
        $state.go('application.membership.retail');
      },
    },

    error: {
      init: function (response) {},
      clearMember: function (response) {
        const self = $scope.membershipList;
        self.showMessage('An error occurred', response.data.error);
      },
    },

    onMembershipListUpdate: function (e, data) {
      const self = $scope.membershipList;

      self.state = data.isLoaded ? 'idle' : 'loading';
      self.notice.hideMessages();

      if (self.state === 'idle' && sidebarService.isShown) {
        sidebarService.hide();
      }
    },

    onMembershipListError: function (
      e: any,
      data: { response: { data: { success: boolean; code: string; error: string } } }
    ) {
      const self = $scope.membershipList;

      self.state = 'error';
      self.notice.showErrorMessages([{ message: data.response.data.error }]);
    },

    onSearchCardholdersUpdate: function (n, o) {
      // Do nothing
    },

    onSearchTypeUpdate: function (n, o) {
      const self = $scope.membershipList;

      if (n !== o) {
        self.searchQuery = '';
      }
    },

    onDestroy: function () {
      if ($scope.membershipList.queryTimer) {
        $timeout.cancel($scope.membershipList.queryTimer);
      }
    },
  };

  $scope.membershipList.init();
}

export const MembershipListControllerModule = angular
  .module('acme.view.application.membership.list.controllers', [
    uiRouter,
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.viewState',
    'acme.common.service.featureToggle',
    'acme.common.service.permissions',
    CartServiceModule,
    SidebarServiceModule,
    AdvancedFiltersServiceModule,
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.factory.notice',
    FocusDirectiveModule,
    EmptySectionComponentModule,
    TabsComponentModule,
    'acme.common.component.filterbar',
    AdvancedFiltersComponentModule,
    NoticesComponentModule,
    MembershipListCardholdersControllerModule,
    MembershipListOrganizationsControllerModule,
    'acme.view.application.modals.confirm.controllers',
  ])
  .controller('MembershipListController', MembershipListController).name;
